<template>
  <div class="best-offer-view">

    <section class="start-section">
      <div class="inner-content-wraper">
        <div class="box">
          <h1 class="lp-title" v-html="$t('view.component.bestOffer.startSection.pageTitle')"></h1>
        </div>
        <div class="box circle-orange">
          <p class="main-subtitle" v-html="$t('view.component.bestOffer.startSection.circleText')"></p>
          <p class="small-subtitle" v-html="$t('view.component.bestOffer.startSection.smallCircleText')"></p>
        </div>
      </div>
    </section>

    <section class="black-section">
      <div class="inner-content-wraper">
        <div class="box">
          <h2 class="lp-subtitle text-white">{{$t('view.component.bestOffer.blackSection.title')}}</h2>
          <ul class="main-list--bigger text-white main-text">
            <li v-html="$t('view.component.bestOffer.blackSection.list.text1')"></li>
            <li v-html="$t('view.component.bestOffer.blackSection.list.text2')"></li>
            <li v-html="$t('view.component.bestOffer.blackSection.list.text3')"></li>
            <li v-html="$t('view.component.bestOffer.blackSection.list.text4')"></li>
          </ul>
        </div>
      </div>
    </section>

    <section class="gray-section">
      <div class="inner-content-wraper">
        <div class="box">
          <h2 class="lp-subtitle">{{$t('view.component.bestOffer.graySection.title')}}</h2>
        </div>
        <div class="box box-container--white">
            <div class="box">
              <h3 class="main-subtitle text-orange">{{$t('view.component.bestOffer.graySection.box1.title')}}</h3>
              <hr />
              <p class="main-text" v-html="$t('view.component.bestOffer.graySection.box1.text')"></p>
            </div>
            <div class="box">
              <h3 class="main-subtitle text-orange">{{$t('view.component.bestOffer.graySection.box2.title')}}</h3>
              <hr />
              <p class="main-text" v-html="$t('view.component.bestOffer.graySection.box2.text')"></p>
            </div>
            <div class="box">
              <h3 class="main-subtitle text-orange">{{$t('view.component.bestOffer.graySection.box3.title')}}</h3>
              <hr />
              <p class="main-text" v-html="$t('view.component.bestOffer.graySection.box3.text')"></p>
            </div>
        </div>
        <div class="box additional-text">
          <p class="main-subtitle text-orange" v-html="$t('view.component.bestOffer.graySection.additionalText.text1')"></p>
<!--          <p class="main-subtitle" v-html="$t('view.component.bestOffer.graySection.additionalText.text2')"></p>-->
        </div>
      </div>
    </section>

    <section class="banner-section" v-if="this.lang === 'pl'">
      <div class="banner-image">
        <a href="https://www.orange.pl/view/oferta-na-karte" target="_blank">
          <img class="mobile" src="/images/orange/best-offer/1200x485.jpg" alt="Najtańsze gigabajty w Orange na kartę">
          <img class="desktop" src="/images/orange/best-offer/1200x485.jpg" alt="Najtańsze gigabajty w Orange na kartę">
        </a>
      </div>
<!--      <div class="banner-section-text">-->
<!--        <div class="white-text">-->
<!--          <p class="white-text1">{{$t('view.component.bestOffer.bannerSection.text1')}}</p>-->
<!--          <p class="white-text2">{{$t('view.component.bestOffer.bannerSection.text1_1')}}</p>-->
<!--          <p class="white-text3">{{$t('view.component.bestOffer.bannerSection.text1_2')}}</p>-->
<!--          <button class="box white-text" v-html="$t('view.component.bestOffer.bannerSection.button')"></button>-->
<!--        </div>-->
<!--        <div class="black-text">-->
<!--        </div>-->
<!--      </div>-->
    </section>

    <a href="https://www.orange.pl/view/kup-starter" title="Przejdź do strony z zakupem startera"><section class="graphic-banner" v-if="this.lang === 'pl'"></section></a>

    <section class="equally-divided-section">
        <div class="box"></div>
        <div class="box">
          <div class="inner-content-half-wraper">
            <h2 class="lp-subtitle text-orange" v-html="$t('view.component.bestOffer.equallyDividedSection.title')"></h2>
            <ul class="main-list--bigger text-white main-text">
              <li v-html="$t('view.component.bestOffer.equallyDividedSection.list.text1')"></li>
              <li v-html="$t('view.component.bestOffer.equallyDividedSection.list.text2')"></li>
              <li v-html="$t('view.component.bestOffer.equallyDividedSection.list.text3')"></li>
              <li v-html="$t('view.component.bestOffer.equallyDividedSection.list.text4')"></li>
              <li v-html="$t('view.component.bestOffer.equallyDividedSection.list.text5')"></li>
            </ul>
          </div>
        </div>
    </section>

    <section class="white-section">
      <div class="inner-content-wraper">
        <div class="box">
        </div>
        <div class="box" v-html="$t('view.component.bestOffer.whiteSection.button')"></div>
        <div class="box">
          <span v-html="$t('view.component.bestOffer.whiteSection.regulations')"></span>
          <p class="main-text">{{$t('view.component.bestOffer.whiteSection.annotation')}}</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

export default {
  name: 'BestOfferView',
  computed: {
    lang: function () {
      return this.$i18n.locale()
    }
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_best-offer.scss"></style>
